/**
 * Test IDs for QA automation.
 */
export const testIds = {
  trailerDetailsDelete: "trailer-details-delete",
  trailerDetailsEdit: "trailer-details-edit",
  trailerDetailsAddEvent: "trailer-details-add-event",
  trailerDetailsOpen: "trailer-details-open",
  trailerDetailsClose: "trailer-details-close",
} as const;
